import { useFlowDefinition } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { FlowBuilder } from "@/features/catalog/flows/flow-builder";
import { flowDefinitionUrlFromRouteId } from "@/features/catalog/lib/flow-definition-route";

export const Route = createFileRoute("/catalog/flows/$flowId")({
  component: FlowComponent,
});

function FlowComponent() {
  const { flowId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const flow = useFlowDefinition(flowDefinitionUrlFromRouteId(flowId));
  if (!flow) return <p className="p-4 text-muted-foreground text-sm">Loading flow…</p>;
  // Remount per revision: a save mints server ids for nodes drawn as new, and
  // the canvas must pick those up rather than keep its temporary ones.
  return (
    <div className="flex h-full min-h-0 flex-col">
      <FlowBuilder key={`${flow.url}|${flow.version}`} flow={flow} canEdit={permissions.canWrite("PlanDefinition")} />
    </div>
  );
}
